import { useRef, useState } from 'react'
import { useFocusRef } from '../useFocusRef'

interface UseCodeEntry {
  codeEntryRef: React.MutableRefObject<HTMLInputElement | null>
  codeEntryKey: number
  resetCodeEntry: () => void
}

export const useCodeEntry = (): UseCodeEntry => {
  const codeEntryRef = useRef<HTMLInputElement | null>(null)
  const [codeEntryKey, setCodeEntryKey] = useState(0)
  const resetCodeEntry = (): void => {
    setCodeEntryKey(codeEntryKey + 1)
    setTimeout(() => {
      if (codeEntryRef.current != null) {
        codeEntryRef.current.focus()
      }
    }, 0)
  }
  // @ts-ignore: OPERATION BLEED STOPPER
  useFocusRef(codeEntryRef)
  return {
    codeEntryRef,
    codeEntryKey,
    resetCodeEntry,
  }
}
